import { $t } from "../../../utils/intl";
import { handleNumberField } from "../../prefill/helpers";
import { FieldRegistryConfig } from "../../types";
import { fieldsText } from "../fields.text";
import { TextFieldValue } from "../text/text.config";
import { PercentFieldControl } from "./PercentFieldControl/PercentFieldControl";
import { defaultToReviewString } from "../review/reviewString.helpers";

export const percentFieldConfig: FieldRegistryConfig<TextFieldValue> = {
  icon: "percent",
  control: (props) => (
    <PercentFieldControl placeholder={$t(fieldsText.percentPlaceholder)} type="number" {...props} />
  ),
  prefill: handleNumberField,
  toReviewString: defaultToReviewString,
};
